import { render, staticRenderFns } from "./DialogEditLabel.vue?vue&type=template&id=5f7a2ce0&"
import script from "./DialogEditLabel.vue?vue&type=script&lang=js&"
export * from "./DialogEditLabel.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditLabel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports